import type { Colors, DefaultTheme } from 'styled-components';
import { darkColors, mapDarkTheme } from './DarkTheme';

const colors: Colors = {
  ...darkColors,
  primary: {
    lighten: '#006AFF',
    default: '#014AC3',
    dim: 'rgba(1,74,195,0.4)',
    mute: 'rgba(1,74,195,0.1)',
  },
  gray: {
    '100': '#ffffff',
    '000': '#030304',
    '010': '#2E3439',
    main: '#181A22',
    '020': '#25272e',
    '030': '#33353a',
    '040': '#414346',
    '050': '#484a4c',
    '060': '#515355',
    '070': '#616363',
    '080': '#8b8c88',
    '090': '#abaca4',
  },
  green: {
    lighten: '#1CB854',
    default: '#0E8450',
    dim: 'rgba(14,132,80,0.4)',
    mute: 'rgba(14,132,80,0.1)',
  },
  red: {
    lighten: '#E53C43',
    default: '#AF1631',
    dim: 'rgba(175,22,49,0.4)',
    mute: 'rgba(175,22,49,0.1)',
  },
  yellow: {
    lighten: '#FFA02E',
    default: '#B75F17',
    dim: 'rgba(183,95,23,0.4)',
    mute: 'rgba(183,95,23,0.1)',
  },
  blue: {
    lighten: '#5097FE',
    default: '#2880FE',
    dim: 'rgba(40,128,254,0.4)',
    mute: 'rgba(40,128,254,0.1)',
  },
  purple: darkColors.purple,
};

export const DarkRipplePrimeTheme: DefaultTheme = mapDarkTheme(colors, {
  name: 'DarkRP',

  spacingLayout: 16,
  spacingContent: 8,

  borderRadiusContent: 8,
  borderRadiusButtonDefault: 8,
  borderRadiusButtonSmall: 6,
  borderRadiusButtonTiny: 4,

  backgroundBody: `${colors.gray.main} url(/customers/CapsulesDark.png)`,
  backgroundBodyRepeat: 'repeat',
  backgroundBodySize: '480px 240px',

  backgroundHeader: colors.primary.default,
  borderColorHeader: colors.primary.default,
  backgroundSidebar: colors.gray['010'],
});
